import {axios} from '@http_client';

// ************************ API

/**
 * @param mobile {number}
 * @param city_id {number}
 * @param district_id {number}
 * @param deal_type {string}
 * @param type {string}
 * @param price {number}
 * @param rent {number}
 * @param mortgage {number}
 * @param captcha_code {number|nullable}
 * @param source {String|badesaba|2nabsh}
 * @param name {String|nullable}
 * @param tag {String|nullable}
 *
 * @return Promise
 * */
export function storeInvestment({mobile, city_id, district_id, deal_type, type = null, price, rent, mortgage, captcha_code, source, name = '', tag = ''}) {
    const path = '/v1/investment/request';

    const data = {
        mobile: mobile,
        city_id: city_id,
        district_id: district_id,
        deal_type: deal_type,
        type: type,
        price: price,
        rent: rent,
        mortgage: mortgage,
        captcha_code: captcha_code,
        source: source,
        name: name,
        tag: tag
    };

    return new Promise((resolve, reject) => {
        axios.post(path, data).then(result => {
            resolve(result.data)
        }).catch(error => {
            reject(error);
        })
    })
}

/**
 * @param mobile {number}
 * @param full_name {string|nullable}
 *
 * @return Promise
 * */
export function storeInvestmentRequestRezaTower({mobile, full_name = null}) {
    const path = '/v1/investment/request/rezaTower';

    const data = {
        mobile: mobile,
        full_name: full_name
    };

    return new Promise((resolve, reject) => {
        axios.post(path, data).then(result => {
            resolve(result.data)
        }).catch(error => {
            reject(error);
        })
    })
}

/**
 * @param mobile {number}
 * @param full_name {string|nullable}
 *
 * @return Promise
 * */
export function storeInvestmentRequestHayaat({mobile, full_name = null}) {
    const path = '/v1/investment/request/hayaat';

    const data = {
        mobile: mobile,
        full_name: full_name
    };

    return new Promise((resolve, reject) => {
        axios.post(path, data).then(result => {
            resolve(result.data)
        }).catch(error => {
            reject(error);
        })
    })
}


// ************************* Helpers


// ********************* Exports